// extracted by mini-css-extract-plugin
export default {"more":"AlbumDetailPage_more__9hVX1"};